<template>
    <ValidationObserver v-slot="{ invalid }" tag="div" :slim="true" ref="observer">
        <form @submit.prevent="submit" :key="_uid">
            <el-error :error="error"></el-error>

            <!-- Form content -->
            <div name="default" class="content" :class="contentClass">
                <slot></slot>
            </div>

            <!-- Submit handler -->
            <div v-if="!hideFooter" class="form-footer flex items-center w-full mt-16">
                <el-button :class="buttonClass" :loading="loading" :success="success" :loadingLabel="loadingText" :successLabel="successText" :defaultLabel="submitText" :disabled="invalid || disabled || success"></el-button>
                <span class="text-blue opacity-70 text-14 lg:ml-24 ml-16" v-if="disclaimer" v-html="disclaimer"></span>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import nl from 'vee-validate/dist/locale/nl.json';
for (let rule in rules) {
    extend(rule, {
        ...rules[rule],
        message: nl.messages[rule]
    });
}

export default {
    name: "Forms.Elements.ElForm",

    components: {
        ValidationObserver,
        ElError: () => import(/* webpackChunkName: "elements" */ "./ElError"),
        ElButton: () => import(/* webpackChunkName: "elements" */ "./ElButton")
    },

    props: {
        loading: {
            type: [Boolean],
            default: false,
            required: false
        },

        success: {
            type: [Boolean],
            default: false,
            required: false
        },

        error: {
            default: false,
            required: false
        },

        submitText: {
            required: false,
            type: String,
            default: "Verstuur"
        },
        loadingText: {
            required: false,
            type: String,
            default: "Versturen"
        },
        successText: {
            required: false,
            type: String,
            default: "Verstuurd!"
        },

        buttonClass: {
            default: "btn-inline"
        },

        disabled: {
            default: false
        },

        contentClass: {
            required: false,
            type: String,
        },

        hideFooter: {
            required: false,
            type: Boolean,
            default: false
        },

        disclaimer: {
            required: false,
            type: String,
        }
    },

    mounted() {
        this.$nextTick().then(() => this.$emit("loaded"));
    },

    methods: {
        submit() {
            this.$emit("submit");
        }
    }
};
</script>
